

let _ = require('../_.js');
let $ = jQuery;

_.AuctionUI_Main = class AuctionUI_Main {

    static _old_track_id = null

    static async init() {
        return;
        console.log('Started AuctionCast UI Main Module');

        _.AuctionUI_Data.on_data_update("auction", async function (auction) {
            // console.log(auction);

            $(".ac-widget-name-auction-title").text((await auction.property.fetch()).title);

            $(".ac-widget-name-auction-badge-status")
                .text(auction.status_label_frontend)
                .attr('class', function (i, c) {
                    return c.replace(/(^|\s)badge-\S+/g, '');
                })
                .addClass("badge").addClass(auction.status_badge_frontend);
        });
    }
}
